/**
 * Finds ancestor of DOM element by given class name
 *
 * @param {element} el
 * @param {string} className - Parent's class name
 * @returns {element}
 */
export default function findAncestor(el, className) {
  while ((el = el.parentElement) && !el.classList.contains(className));
  return el;
}
